export const environment = {
  production: true,
  googleMapsApiKey: 'AIzaSyCL02LfEz3dwuD9bnaLi_5NWloKBkSR2Ak',
};
